import {useState} from "react";
import {Box, InputBase} from "@mui/material";
import {splitNumbers} from "../../../../project/campaigns/utils";
import {controlSx, FieldLabel} from "./formFieldShared";

// Paste numbers (one per line) or type one and press Enter
export const PhoneNumbersInputNew = ({onAdd, label = "Phone numbers"}) => {
  const [value, setValue] = useState("");

  const handlePaste = (e) => {
    const values = splitNumbers(e.clipboardData?.getData("text"));
    if (values.length === 0) return;
    e.preventDefault();
    onAdd(values);
    setValue("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onAdd(splitNumbers(value));
      setValue("");
    }
  };

  return (
    <>
      <FieldLabel>{label}</FieldLabel>
      <Box sx={controlSx}>
        <InputBase
          fullWidth
          placeholder="Paste phone numbers (one per line) or type one and press Enter"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onPaste={handlePaste}
          onKeyDown={handleKeyDown}
          inputProps={{"aria-label": label}}
          sx={{flex: 1, fontSize: 13, color: "#23264D"}}
        />
      </Box>
    </>
  )
}
